import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  set(key: string, data: any): void {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.setItem(key, JSON.stringify(data));
  }

  get<T>(key: string): T | null {
    if (!isPlatformBrowser(this.platformId)) return null;

    const localStoredData = localStorage.getItem(key);
    if (!localStoredData)
      return null;

    try {
      return JSON.parse(localStoredData) as T;
    } catch (error) {
      if (!environment.production) console.error(`LocalStorage: Failed to parse data for key "${key}". Removing corrupted entry.`, error);
      this.remove(key);
      return null;
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
